import axios from "@/config/axios.config";

import siteApi from "@/api/site";

import bdMap from "@/utils/bdMap";

// 发送验证码
export function sendCode(data) {
	return axios({
		method: "post",
		url: siteApi.sendCodeUrl,
		noLogin: true,
		data,
	});
}

// 绑定手机
export function bindPhone(data) {
	return axios({
		method: "post",
		url: siteApi.bindPhoneUrl,
		data,
	});
}

// 根据定位获取周围地址
export function getAround(data) {
	return axios({
		method: "post",
		url: siteApi.getAroundUrl,
		data,
	});
}

// 搜索地址
export function searchAddress(data) {
	return axios({
		method: "post",
		url: siteApi.searchAddressUrl,
		data,
	});
}

// 搜索商务楼
export function searchBuilding(data, noToast = false) {
	return axios({
		method: "post",
		url: siteApi.searchBuildingUrl,
		data,
		noToast,
	});
}

// 市列表
export function area() {
	return axios({
		method: "post",
		url: siteApi.areaUrl,
	});
}

// 更改绑定手机号
export function bindAgain(data) {
	return axios({
		method: "post",
		url: siteApi.bindAgainUrl,
		data,
	});
}

// 企业微信注册
export function getCorpConfig(data) {
	return axios({
		method: "post",
		url: siteApi.getCorpConfigUrl,
		data,
	});
}

// 确认当前定位城市是否有门店
export function checkArea(data) {
	return axios({
		method: "post",
		url: siteApi.checkAreaUrl,
		data,
	});
}
